export default __webpack_public_path__ + "static/media/sowmz-new-crop.5ac58ba2.jpg";